module.exports = __webpack_public_path__ + "static/media/hoverFlowStatistics.b447eac4.svg";